// Note: This does not apply to the concierge header.

const HEADER_HEIGHTS = {
  xs: {
    cartPage: 82,
    regularPage: 106
  },
  default: {
    cartPage: 132,
    regularPage: {
      newNav: 136,
      oldNav: 148
    }
  }
} as const;

export const getRhrHeaderHeight = (
  isCartPage: boolean,
  size: "default" | "xs",
  FEATURE_NEW_GLOBAL_NAV: boolean = false
): number => {
  if (size === "xs") {
    return isCartPage
      ? HEADER_HEIGHTS.xs.cartPage
      : HEADER_HEIGHTS.xs.regularPage;
  }

  if (isCartPage) {
    return HEADER_HEIGHTS.default.cartPage;
  }

  return FEATURE_NEW_GLOBAL_NAV
    ? HEADER_HEIGHTS.default.regularPage.newNav
    : HEADER_HEIGHTS.default.regularPage.oldNav;
};
